export const SAVE_ELEMENTS_STORE = 'SAVE_ELEMENTS_STORE';
export const MERGE_DATA_GEO = 'MERGE_DATA_GEO';
export const CHANGE_CURRENT_KEY = 'CHANGE_CURRENT_KEY';
export const SAVE_SCALES = 'SAVE_SCALES';
export const CHANGE_CURRENT_SCALE = 'CHANGE_CURRENT_SCALE';
export const CHANGE_PARAMETER_FILTER = 'CHANGE_PARAMETER_FILTER';
export const SAVE_DATA = 'SAVE_DATA';
export const SAVE_DATA_GEO = 'SAVE_DATA_GEO';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_FAILURE = 'FETCH_FAILURE';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js